import { render, staticRenderFns } from "./EmergFailoverDest.vue?vue&type=template&id=13d13a4e"
import script from "./EmergFailoverDest.vue?vue&type=script&lang=js"
export * from "./EmergFailoverDest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports